import React from "react"
import styles from "./Button.module.scss"

const Button = (props) => {

  return (
    <button
      onClick={props.onClick}
      className={[styles.Button,
        styles[props.type],
        styles[props.color],
        styles[props.size],
        styles[props.textSize],
        (props.rightArrow || props.leftArrow) && styles.hasArrow,
        props.block && styles.block,
        props.disabled && styles.disabled,
        props.hoverOutlined && styles.hoverOutlined
      ].join(" ")}
    >
      {
        props.leftIcon && <div className={styles.icon}>
          {
            props.leftIcon
          }
        </div>
      }
      <div>
        {
          props.children
        }
      </div>
      {
        props.rightIcon && <div className={styles.icon}>
          {
            props.rightIcon
          }
        </div>
      }
      {
        props.rightArrow &&
          <i className={[styles.rightArrow, 'd-flex'].join(" ")}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.375 3.75L11.625 9L6.375 14.25" stroke="#0A195C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </i>
      }
    </button>
  )
}

export default Button